import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";

const LoadingPage = () => {
  return (
    <Box sx={{ width: "100%" }}>
      <LinearProgress />
    </Box>
  );
};

export default LoadingPage;
